<template>
	<v-container fluid class="grey lighten-3 py-0 customer-dashboard">
		<v-container fluid class="d-flex pa-0">
			<dashboard-overview
				:credits="credits"
				:invoices="filteredInvoices"
				:shipments="filteredShipments"
				:orders="filteredOrders"></dashboard-overview>
		</v-container>
		<v-container
			fluid
			class="d-flex justify-center pa-0 flex-wrap flex-md-nowrap flex-lg-nowrap dashboard-row">
			<pie-card v-if="!isLoading" :data="pieData"></pie-card>
			<line-card v-if="!isLoading" :data="lineData"></line-card>
			<v-card
				elevation="0"
				class="rounded-xl overflow-y-auto top-products-card"
				outlined
				width="100%">
				<v-card-text class="">
					<v-row>
						<v-col cols="10" class="text-h5 text-center">
							Top Purchased Products
						</v-col>
						<v-col cols="2" class="text-h5">Qty</v-col>
					</v-row>
					<v-row
						v-for="rank in productRankings"
						:key="rank.id"
						style="border-bottom: 1px lightgray solid">
						<v-col cols="10" class="d-flex align-center">
							<div>
								<img
									class="image-preview"
									:src="
										getProductPictureUrlById(rank.pictureId)
									" />
							</div>
							<div>{{ rank.title }}</div>
						</v-col>
						<v-col cols="2" class="d-flex align-center text-h5">
							{{ rank.quantity }}
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
		<v-container
			fluid
			class="d-flex px-0 flex-wrap flex-md-nowrap flex-lg-nowrap dashboard-row dashboard-detail-row">
			<v-container
				fluid
				class="py-0 white rounded-xl d-none d-md-block d-lg-block child-accounts-panel">
				<v-container fluid>
					<div class="text-h6">Child Accounts</div>
				</v-container>
				<v-list rounded>
					<v-list-item-group v-model="selectedChild">
						<template
							v-for="(
								childCustomer, idx
							) in customer.childCustomers">
							<v-list-item :key="`customer-${childCustomer.id}`">
								<v-list-item-content>
									<v-list-item-title>
										{{ getCustomerName(childCustomer.id) }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-divider
								v-if="idx < customer.childCustomers.length - 1"
								:key="`divider-${idx}`"></v-divider>
						</template>
					</v-list-item-group>
				</v-list>
			</v-container>
			<v-container
				fluid
				class="py-0 white rounded-xl d-md-none d-lg-none mb-2 child-accounts-panel-mobile">
				<v-container fluid>
					<div class="text-h6">Child Accounts</div>
				</v-container>
				<v-list rounded>
					<v-list-item-group v-model="selectedChild">
						<template
							v-for="(
								childCustomer, idx
							) in customer.childCustomers">
							<v-list-item :key="`customer-${childCustomer.id}`">
								<v-list-item-content>
									<v-list-item-title>
										{{ getCustomerName(childCustomer.id) }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-divider
								v-if="idx < customer.childCustomers.length - 1"
								:key="`divider-${idx}`"></v-divider>
						</template>
					</v-list-item-group>
				</v-list>
			</v-container>
			<v-container
				fluid
				class="py-0 px-0 white rounded-xl dashboard-table-panel">
				<v-tabs v-model="tab">
					<v-tab>Invoices</v-tab>
					<v-tab>Payments</v-tab>
					<v-tab>Shipments</v-tab>
					<v-tab>Orders</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab" touchless>
					<v-tab-item>
						<invoice-list
							v-model="filteredInvoices"
							:custom-headers="[
								'id',
								'mtlTracking',
								'customerId',
								'description',
								'boxCasePallet',
								'weight',
								'totalAmount',
								'paymentStatusId',
								'collector',
								'dateCreated',
								'invoiceDate',
							]"></invoice-list>
					</v-tab-item>
					<v-tab-item>
						<payment-list
							:value="filteredPayments"
							:show-title="false"
							:custom-headers="[
								'id',
								'invoiceId',
								'amount',
								'credited',
								'typeId',
								'paymentDate',
								'accountId',
								'description',
								'createdBy',
								'action',
							]"></payment-list>
					</v-tab-item>
					<v-tab-item>
						<shipment-list
							class="mb-2"
							:shipments="filteredShipments"></shipment-list>
					</v-tab-item>
					<v-tab-item>
						<v-container
							fluid
							class="d-flex white rounded-xl flex-wrap order-row"
							v-for="(order, idx) in orders"
							:key="`order-${order.id}`">
							<order-card
								:order="order"
								@handle-event="openDialog"></order-card>
							<order-options
								class="d-none d-sm-none d-md-none d-lg-block"
								v-model="orders[idx]"
								@delete-event="refilterOrders"></order-options>
						</v-container>
					</v-tab-item>
				</v-tabs-items>
			</v-container>
		</v-container>
		<v-dialog v-model="dialog" max-width="350">
			<order-options
				show-id
				v-model="selectedOrder"
				@delete-event="refilterOrders"></order-options>
		</v-dialog>
	</v-container>
</template>
<script>
import ShipmentList from "./ShipmentList.vue";
import InvoiceList from "./InvoiceList.vue";
import PaymentList from "./PaymentList.vue";
import OrderCard from "./OrderCard.vue";
import OrderOptions from "./OrderOptions.vue";
import DashboardOverview from "./DashboardOverview.vue";
import backendService from "@/services/backend-service";
import generalMixin from "@/js/general-mixin";
import Decimal from "decimal.js";
import PieCard from "./PieCard.vue";
import LineCard from "./LineCard.vue";
import eventBus from "@/js/event-bus.js";
export default {
	name: "CustomerDashboard",
	mixins: [generalMixin],
	components: {
		"shipment-list": ShipmentList,
		"invoice-list": InvoiceList,
		"payment-list": PaymentList,
		"dashboard-overview": DashboardOverview,
		"pie-card": PieCard,
		"line-card": LineCard,
		"order-card": OrderCard,
		"order-options": OrderOptions,
	},
	mounted: function () {
		eventBus.$on("generateInvoiceCsv", this.generateInvoiceCsv);
		if (this.customer && this.customer.id) {
			this.getDetails();
		}
	},
	props: {
		customer: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			orders: [],
			invoices: [],
			payments: [],
			shipments: [],
			pieData: {},
			lineData: {},
			isLoading: true,
			productRankings: [],
			selectedChild: null,
			dialog: false,
			selectedOrder: {},
		};
	},
	computed: {
		tab: {
			get() {
				return this.$store.getters["interactStore/customerDetailTab"];
			},
			set(val) {
				this.$store.commit("interactStore/setCustomerDetailTab", val);
			},
		},
		credits() {
			if (this.customer && this.customer.id)
				return {
					dongCredit: this.customer.dongCredit,
					dollarCredit: this.customer.dollarCredit,
				};
			return {};
		},
		filteredOrders() {
			if (this.orders.length == 0) return [];
			if (!this.customer || !this.customer.id) return this.orders;
			return this.orders.filter((e) => e.customerId == this.customer.id);
		},
		filteredShipments() {
			if (this.shipments.length == 0) return [];
			if (!this.customer || !this.customer.id) return this.shipments;
			let childCustomer = null;
			if (this.selectedChild >= 0)
				childCustomer =
					this.customer.childCustomers[this.selectedChild];

			return this.shipments.filter(
				(e) =>
					(childCustomer && childCustomer.id == e.senderId) ||
					(!childCustomer &&
						(e.senderId == this.customer.id ||
							e.parentCustomerId == this.customer.id))
			);
		},
		filteredInvoices() {
			if (this.invoices.length == 0) return [];
			if (!this.customer || !this.customer.id) return this.invoices;
			let childCustomer = null;
			if (this.selectedChild >= 0)
				childCustomer =
					this.customer.childCustomers[this.selectedChild];

			return this.invoices.filter(
				(e) =>
					(childCustomer && childCustomer.id == e.customerId) ||
					(!childCustomer &&
						(e.customerId == this.customer.id ||
							e.parentCustomerId == this.customer.id))
			);
		},
		filteredPayments() {
			if (this.payments.length == 0) return [];
			if (!this.customer || !this.customer.id) return this.payments;
			let childCustomer = null;
			if (this.selectedChild >= 0)
				childCustomer =
					this.customer.childCustomers[this.selectedChild];

			return this.payments.filter(
				(e) =>
					(childCustomer && childCustomer.id == e.accountId) ||
					(!childCustomer &&
						(e.accountId == this.customer.id ||
							e.parentCustomerId == this.customer.id))
			);
		},
	},
	methods: {
		generateInvoiceCsv() {
			const invoices = this.filteredInvoices;
			let headerStr =
				"Id;Tracking #;Customer;Description;Box/Case/Pallet;Weight;Currency;Total Amount;Payment;Invoice Date";
			let csvContent = "";
			csvContent += headerStr + "\r\n";
			for (let i = 0; i < invoices.length; i++) {
				const invoice = invoices[i];
				const invoiceDate =
					invoice.invoiceDate == null
						? invoice.dateCreated
						: invoice.invoiceDate;
				let rowStr = `${this.formatInvoiceId(invoice)};${
					invoice.mtlTracking ? invoice.mtlTracking : ""
				};${this.getCustomerName(invoice.customerId)};"${
					invoice.description
				}";${invoice.boxCasePallet};${
					invoice.weight ? invoice.weight : 0
				};${this.getCurrencySymbol(invoice.currencyId)};${
					invoice.totalAmount
				};${this.getOptionName(
					invoice.paymentStatusId
				)};${this.convertToDate(
					invoiceDate,
					invoice.invoiceDate == null
				)}`;
				csvContent += rowStr + "\r\n";
			}
			let blob = new Blob([csvContent], { type: "text/plain" });
			let url = URL.createObjectURL(blob);
			let link = document.createElement("a");
			link.setAttribute("href", url);
			link.setAttribute(
				"download",
				`${this.getCustomerName(this.customer.id, false)}-statement-${
					new Date().toLocaleString().split(",")[0]
				}.csv`
			);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		getDetails() {
			backendService.getShipments().then((response) => {
				this.shipments = response.data;
			});
			backendService.getInvoices().then((response) => {
				this.invoices = response.data;
			});
			backendService.getPayments().then((response) => {
				this.payments = response.data;
			});
			backendService
				.getOrdersByCustomerId(this.customer.id)
				.then((response) => {
					this.orders = response.data;
					this.getProductRankings();
				});
			this.timer(2000).then(() => {
				this.getPieChartData();
				this.getLineChartData();
				this.isLoading = false;
			});
		},
		getLineChartData() {
			let invoices = this.filteredInvoices;
			let data = [];
			let labels = [];
			let dict = {};
			for (let i = 0; i < invoices.length; i++) {
				let invoice = invoices[i];
				let dateArr = invoice.dateCreated.split("-");
				let dateStr = `${dateArr[0]}/${dateArr[1]}`;
				if (!dict[dateStr]) {
					dict[dateStr] = new Decimal(0);
				}
				let amount = new Decimal(invoice.totalAmount);
				if (invoice.currencyId == this.Dong) {
					amount = this.convertToUsDollar(invoice.totalAmount);
				}

				dict[dateStr] = dict[dateStr].plus(amount);
			}
			labels = Object.keys(dict).sort();
			for (let i = 0; i < labels.length; i++) {
				data.push(parseFloat(dict[labels[i]].toFixed(2)));
			}
			let datasets = [
				{
					label: "Invoice Amount",
					borderColor: "#FFAB5B",
					data: data,
					tension: 0.1,
				},
			];

			this.lineData = {
				labels: labels,
				datasets: datasets,
			};
			this.$forceUpdate();
		},
		getPieChartData() {
			let invoices = this.filteredInvoices;
			let data = [];
			let labels = [];
			let dict = {};
			for (let i = 0; i < invoices.length; i++) {
				let invoice = invoices[i];
				let type = this.getOptionName(invoice.typeId);
				if (!dict[type]) {
					dict[type] = new Decimal(0);
				}
				let amount = new Decimal(invoice.totalAmount);
				dict[type] = dict[type].plus(amount);
			}
			labels = Object.keys(dict).sort();

			for (let i = 0; i < labels.length; i++) {
				data.push(parseFloat(dict[labels[i]].toFixed(2)));
			}
			let datasets = [
				{
					backgroundColor: [
						"#ff5454",
						"#ff9354",
						"#d7ff54",
						"#54ffac",
						"#54e8ff",
						"#a454ff",
						"#ff54ff",
					],
					data: data,
				},
			];

			this.pieData = {
				labels: labels,
				datasets: datasets,
			};
			this.$forceUpdate();
		},
		getProductRankings() {
			let dict = {};
			for (let i = 0; i < this.orders.length; i++) {
				let order = this.orders[i];
				for (let j = 0; j < order.orderDetails.length; j++) {
					let orderDetail = order.orderDetails[j];
					if (!dict[orderDetail.productId]) {
						let product = {};
						product.title = orderDetail.productTitle;
						product.id = orderDetail.productId;
						product.pictureId = orderDetail.pictureId;
						product.quantity = 0;
						dict[product.id] = product;
					}
					dict[orderDetail.productId].quantity +=
						orderDetail.quantity;
				}
			}
			let products = Object.keys(dict).map((key) => {
				return dict[key];
			});
			products.sort((a, b) => {
				if (a.quantity < b.quantity) {
					return 1; // a comes before b
				}
				if (a.quantity > b.quantity) {
					return -1; // a comes after b
				}
				return a.title.localeCompare(b.title);
			});
			this.productRankings = products;
		},
		getProductPictureUrlById(imageId) {
			return backendService.getProductPictureUrlById(imageId);
		},
		openDialog(order) {
			this.selectedOrder = order;
			this.dialog = true;
		},
		refilterOrders(id) {
			this.orders = this.orders.filter((e) => e.id != id);
			this.selectedOrder = {};
			this.dialog = false;
		},
	},
	watch: {
		customer: function (newVal, oldVal) {
			if (newVal.id != oldVal.id) this.getDetails();
		},
	},
};
</script>
<style scoped>
.customer-dashboard {
  max-width: none;
  width: 100%;
}
.dashboard-row {
  gap: 8px;
  max-width: none;
  width: 100%;
}
.dashboard-detail-row {
  align-items: flex-start;
}
.top-products-card {
  height: 400px;
  min-width: 280px;
}
.child-accounts-panel {
  flex: 0 0 clamp(260px, 18vw, 360px);
  max-height: calc(100vh - 220px);
  max-width: 360px;
  min-width: 260px;
  overflow-y: auto;
}
.child-accounts-panel-mobile {
  max-height: 260px;
  overflow-y: auto;
}
.dashboard-table-panel {
  flex: 1 1 0;
  max-width: none;
  min-width: 0;
  overflow: hidden;
  width: auto;
}
.order-row {
  margin-right: 0;
  width: 100%;
}
.image-preview {
  object-fit: contain;
  image-rendering: smooth;
  width: 100px;
  height: 100px;
}
</style>
